import type { AppPreferencesRepository } from '../../../application/ports/AppPreferencesRepository';
import type { AppPreferences } from '../../../domain/preferences/AppPreferences';
import type { AppPreferencesId, ProfileId } from '../../../domain/shared/ids';
import type { AscendInvictusDatabase } from '../AscendInvictusDatabase';
import { AppPreferencesMapper } from '../mappers';
import { executePersistence } from '../translatePersistenceError';

export class DexieAppPreferencesRepository implements AppPreferencesRepository {
  public constructor(private readonly database: AscendInvictusDatabase) {}

  public save(preferences: AppPreferences): Promise<void> {
    return executePersistence('write', async () => {
      await this.database.appPreferences.put(AppPreferencesMapper.toRecord(preferences));
    });
  }

  public findByProfileId(profileId: ProfileId): Promise<AppPreferences | null> {
    return executePersistence('read', async () => {
      const record = await this.database.appPreferences.where('profileId').equals(profileId).first();
      return record ? AppPreferencesMapper.fromRecord(record) : null;
    });
  }

  public delete(id: AppPreferencesId): Promise<void> {
    return executePersistence('write', async () => {
      await this.database.appPreferences.delete(id);
    });
  }
}
